/// <reference types="@types/googlemaps" />
import { Injectable } from '@angular/core';
import { WindowRef, DocumentRef } from './components.util.services';
import { registerModuleFactory } from '@angular/core/src/linker/ng_module_factory_loader';

@Injectable()
export class IdMeServices {

  protected idMeLoadingPromise: Promise<boolean>;
  protected readonly idMeScriptId: string = 'tpsIdMe';
  protected readonly callbackName: string = 'tpsIdMeCallback';

  constructor(
    protected windowRef: WindowRef,
    protected documentRef: DocumentRef
    ) {}

  load(): Promise<boolean> {
    const window = this.windowRef.window;
    const walletButton = this.documentRef.document.getElementById('idme-wallet-button');


    if (walletButton) {

      if (this.idMeLoadingPromise) {
        return this.idMeLoadingPromise;
      }

      const scriptOnPage = this.documentRef.document.getElementById(this.idMeScriptId);

      if (scriptOnPage) {
        this.assignScriptLoadingPromise(scriptOnPage);
        return this.idMeLoadingPromise;
      }

      const script = this.documentRef.document.createElement('script');
      // script.async = true;
      // script.defer = true;
      script.id = this.idMeScriptId;
      script.innerHTML = 'BindIDme();';
      this.assignScriptLoadingPromise(script);
      this.documentRef.document.body.appendChild(script);

      return this.idMeLoadingPromise;
    }

  }

  private assignScriptLoadingPromise(scriptElem: HTMLElement) {

    this.idMeLoadingPromise = new Promise<boolean>((resolve: Function, reject: Function) => {
      (<any>this.windowRef.window)[this.callbackName] = () => {
        resolve();
      };

      scriptElem.onerror = (error: Event) => {
        reject(error);
      };
    });
  }
}
